import { render } from "./PricingTwo.vue?vue&type=template&id=2bb87bd7"
import script from "./PricingTwo.vue?vue&type=script&lang=js"
export * from "./PricingTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__